import DefaultLayout from "../components/layout/DefaultLayout.jsx";

function GoalsPlanner() {
    return (
        <DefaultLayout>
            <div>
                <h2>Yearly Goals Planner coming soon...</h2>
            </div>
        </DefaultLayout>
    );
}

export default GoalsPlanner;